import { Box, Text } from '@chakra-ui/react';
import { prettyDate } from '@pelicargo/utils';

import { fillsPhrase } from './format';
import { ApplySummary } from './payload';

type Props = {
  applied: ApplySummary | null;
};

/**
 * The one-line record of what an apply wrote and when. The flights and quote columns themselves are marked above, so
 * this only names them.
 */
export const AppliedSummary = ({ applied }: Props) => {
  if (!applied) return null;

  const appliedAtUtc = prettyDate(applied.appliedAt, { showTime: true, timeZone: 'UTC' });
  const appliedOn = applied.appliedAt ? ` on ${appliedAtUtc} UTC` : '';
  const written = fillsPhrase(applied.filledCount, applied.quoteFilled);

  return (
    <Box borderWidth="1px" borderRadius="md" p="3">
      <Text fontSize="sm" fontWeight="medium">
        Applied{appliedOn} — {written} filled onto the quote
      </Text>
    </Box>
  );
};
